import AsyncSelect from 'react-select/async';
import axiosInstance from "../../api/axiosInstance";
import { useEffect, useState } from "react"
import Swal from "sweetalert2";
export default function LookupField({ clearTrigger, url, initialValue, onChange, postData = {}, isGet = false }) {
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {
        setSelectedValue(initialValue || null);
    }, [initialValue])

    useEffect(() => {
        if (clearTrigger > 0) {
            setSelectedValue(null)
        }
    }, [clearTrigger]);

    const loadOptions = async (inputValue, callback) => {
        if (!inputValue) {
            return callback([]);
        }

        let request = isGet ? axiosInstance.get(url + inputValue) : axiosInstance.post(url + inputValue, postData);

        await request.then(response => {
            const data = response.data.data;
            const options = data.length > 0 ? data.map(item => ({
                value: item.id,
                label: item.text,
            })) : [];
            callback(options);
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch items. Please try again later.',
            });
            console.error("Error fetching items:", error);
            callback([]);
        });
    };
    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption);
        onChange(selectedOption)
    };

    return (<div style={{ 'minWidth': '300px', 'width': '100%' }}>
        <AsyncSelect
            cacheOptions
            isClearable={true}
            loadOptions={loadOptions}
            defaultOptions={false}
            onChange={handleChange}
            value={selectedValue}
            placeholder="Search for an item..."
            onInputChange={(newValue) => newValue}
        />
    </div>)
}